import script from "./plan-limited-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./plan-limited-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__